import React from "react"
import clsx from "clsx"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"

import { thousandSeparator } from "utils"
import classes from "./PoOrderItem.module.scss"

const PoOrderItem = props => {
  const { orderItem } = props

  const i18n = useTranslation()[1]

  const total =
    orderItem.systemDiscount < 0
      ? (orderItem.salePrice - orderItem.systemDiscount) * orderItem.quantity
      : orderItem.salePrice * orderItem.quantity

  const isLtr = i18n.dir(i18n.language) === "ltr"

  const renderItems = items => items.map(specificationItem =>
    <div className={classes["row"]} key={`${specificationItem.builderStepKey || "whole"}-${specificationItem._id}`}>
      <div className={classes["extraFood"]}>
        {specificationItem.name}<MdClose />{specificationItem.quantity * orderItem.quantity}
      </div>
      {specificationItem.salePrice > 0 &&
        <div className={clsx(classes["specPrice"], isLtr && classes["specPrice-ltr"])}>
          {thousandSeparator(specificationItem.salePrice * (specificationItem.quantity - specificationItem.freeQuantity) * orderItem.quantity)}
        </div>
      }
    </div>
  )
  const portionItems = portion => orderItem.specificationItems.filter(item =>
    portion === "whole" ? !item.portion || item.portion === "whole" : item.portion === portion
  )
  const renderPortion = (faTitle, enTitle, portion) => {
    const items = portionItems(portion)
    return items.length > 0 && <section className={classes["portion"]}>
      <div className={classes["portion-title"]}>{i18n.language === "fa" ? faTitle : enTitle}</div>
      {renderItems(items)}
    </section>
  }

  return (
    <div className={classes["card"]}>
      <div className={classes["row"]}>
        <div className={classes["details"]}>
          <div
            className={clsx(orderItem.isSimple && classes["foodName"])}
          >
            {orderItem.foodName}{"   "}
            <b>{orderItem.quantity}x</b>
          </div>
          {
            !orderItem.isSimple &&
            <div className={classes["optionName"]}>
              ({orderItem.optionName})
            </div>
          }
        </div>

        <div
          className={clsx(
            classes["price"],
            isLtr && classes["price-ltr"]
          )}
        >
          {thousandSeparator(total)}
        </div>
      </div>

      {renderItems(portionItems("whole"))}
      {renderPortion("نیمه اول", "First half", "firstHalf")}
      {renderPortion("نیمه دوم", "Second half", "secondHalf")}
    </div>
  )
}

export default React.memo(PoOrderItem)
